import cn from 'classnames';
import PodcastDestinationLink from 'components/PodcastDestinationLink';
import PodcastInfo from 'components/PodcastInfo';
import styles from './ThreeByOnePodcastInfo.module.scss';

export interface ThreeByOnePodcastInfoProps {
  children?: React.ReactNode;
  className?: string;
}

interface ThreeByOnePodcastInfoComponent
  extends React.FC<ThreeByOnePodcastInfoProps> {
  PodcastName: typeof PodcastInfo.PodcastName;
  EpisodeTitle: typeof PodcastInfo.EpisodeTitle;
}

const ThreeByOnePodcastInfo: ThreeByOnePodcastInfoComponent = ({
  children,
  className,
}) => (
  <PodcastInfo
    as={PodcastDestinationLink}
    className={cn(styles.podcastInfo, className)}
  >
    {children ?? [
      <PodcastInfo.PodcastName className={styles.podcast} key="podcast" />,
      <PodcastInfo.EpisodeTitle className={styles.episode} key="episode" />,
    ]}
  </PodcastInfo>
);

// re-exported on ThreeByOnePodcastInfo for convenience
ThreeByOnePodcastInfo.PodcastName = PodcastInfo.PodcastName;
ThreeByOnePodcastInfo.EpisodeTitle = PodcastInfo.EpisodeTitle;

export default ThreeByOnePodcastInfo;
